import actionTypes from './publishingStatusActionTypes';
import type { ProgressStatus } from '#packages/constants';

const setPublishingStatus = (publishingStatus: ProgressStatus) => ({
  type: actionTypes.SET_PUBLISHING_STATUS,
  publishingStatus,
});

export { setPublishingStatus };
